import React, { useContext } from 'react';

import { Button, ButtonGroup, Overlay } from '@blueprintjs/core';
import { centerPage, dezoomEditor, fitZoom, zoomEditor } from '../../Util/ZoomUtil';
import PageContext from '../../Context/PageContext';
import { isMobile } from 'react-device-detect';

const ZoomCard = () => {

  const { zoomValue, setZoomValue, pageSize, selectedItem, objItems } = useContext(PageContext);

  function zoomEditorEvent() {
    zoomEditor({ setZoomValue, selectedItem, objItems })
  }
  function dezoomEditorEvent() { dezoomEditor({ setZoomValue, selectedItem, objItems }) }
  function fitZoomEvent() { fitZoom({ setZoomValue, pageSize }) }

  return (
    <div>
      <ButtonGroup>
        <Button className='button-editor-bottom' onClick={zoomEditorEvent} icon="plus" />
        <div className='zoom-value'> <span> {Math.floor(zoomValue * 100)} % </span></div>
        <Button className='button-editor-bottom' onClick={dezoomEditorEvent} icon="minus" />
        <Button className='button-editor-bottom' onClick={fitZoomEvent} icon="zoom-to-fit" />
        <Button className='button-editor-bottom' onClick={centerPage} icon="clip" />
      </ButtonGroup>
    </div>
  );
};

export default ZoomCard;